jQuery.fn.extend({
    DynamicFilteredContent: function(params){

		if(! $(this).length) return;
		var el=$(this);

		params.target=params.target ? params.target :'#news-inner';

		var o={
			el: el,
			baseUrl:  el.data('base-url'),
			tags: el.find('.tags a'),
			params: params,
			content: el.parent().find(params.target),
			clearButton: el.find('[data-clear-all]'),
			queue:0,
			nextButton: el.closest('.eightcol').find(params.nextButton)
		};

        var nextButtonOffset = o.nextButton.offset().top;

        /*
        после загрузки изображений и изменений размеров окна нужно пересчитать позицию
        кнопки загрузки
         */

        $(params.target).find('img').on('load', function(){
            nextButtonOffset = o.nextButton.offset().top;
        })
        $(window).on('media.pageStateInit media.pageStateChange', function(){
            nextButtonOffset = o.nextButton.offset().top;
        })
        /********************************************************************/

        $(window).on('media.pageStateInit', function(){
            $(window).on('scroll', function(){
                if(!o.queue && !o.nextButton.data('disabled')){

                    var s = $(window).scrollTop();
                    var h = window.pageState.height;


                    if(s > nextButtonOffset - h){


                        var page = o.nextButton.data('page') ? o.nextButton.data('page') + 1 : 2;

                            o.nextButton.data('page', page)
                            o.update(page, false)


                    }
                }
            })
        })


		o.tagsLoseFocus=function(e){

			if($(e.target).closest(el).length){
				return true;
			}
			if($(e.target).is(el)){
				return true;
			}

			var opened=el.find('.news-inner-tags-container .tags.opened');
			opened.removeClass('opened');
			if(opened.find('a.active').length==0){

				if(el.find('.tags a.active').length){
					var tags=el.find('.tags a.active').eq(0).closest('.tags');
					var type=tags.data('tags-type');
					el.find('.news-tags-menu-types [data-switch-tags-type]').val(type).trigger('change');
					el.find('.news-inner-tags-container .tags.opened').removeClass('opened')
				}
			}


			$(document).off('click', o.tagsLoseFocus);

			return true;
		}

		el.find('[data-clear-all]').click(function(){

			o.tags.removeClass('active');
			o.update();
			return false;
		})


		o.tags.click(function(){

			var c=$(this).closest('.tags');

            if($(this).is('[data-open-tags]')){
                c.addClass('opened');
                return false;
            }

            $(this).toggleClass('active');

			if($(this).is('[data-select-all]')){
				if($(this).hasClass('active'))
					c.find('a').addClass('active');
				else
					c.find('a').removeClass('active');
			}else{
				if(c.find('a.active[data-id]').length==c.find('a[data-id]').length)
					c.find('a[data-select-all]').addClass('active')
				else
					c.find('a[data-select-all]').removeClass('active')
			}

			var type=c.data('tags-type');
			el.find('.news-inner-tags-container .tags').each(function(i,t){
				if($(t).data('tags-type')!=type)
					 $(t).find('a.active').removeClass('active');
			})

      if(!c.find('a.active').length){
          c.addClass('opened');
      }

			o.update();
			return false;
		})

		$(o.el).parent().on('click','.pages a[href]',function(){
			o.el.find('.pages a[href]').removeClass('active');
			$(this).addClass('active');
			o.update($(this).data('page'))
			return false;
		})


		o.parseUrl=function(){

			if(window.location.pathname != o.baseUrl ){
				var url=window.location.pathname.replace(o.baseUrl+'/','');
				url.split('/').forEach(function(i){
					var type	=	i.substr(0,i.indexOf('-'));
					var val		=	i.substr(1+i.indexOf('-'));

					if(type && type!='page' && val ){
						if(o.clearButton.css('display')=='none')
							o.clearButton.show();
							el.find('.news-inner-tags-container .tags[data-tags-type-'+type+']').show();

							$(o.el).find('.news-inner-tags-container .tags.opened').removeClass('opened')
							$(o.el).find('.news-inner-tags-container .tags[data-tags-type='+type+']').find('a[data-url='+i+']').addClass('active');

					}
				})
				return false;
			}else{
				var params={filters:{}};
				var str=window.location.hash.replace('#','');
				if(str){
					var ar=str.split('&')
					ar.forEach(function(a){
						var s1=a.split('=');
						var name=s1[0];

						if(name=='page')
								params[name]=s1[1];
						else{
							var vals=s1[1].split('-');
							params.filters[name]=vals;
						}
					})
				}

				return(params);
			}
		}
		o.load = function(data,scroll){
			scroll = ( scroll != undefined ) ? scroll : true;
			o.queue++;

			$.ajax({
					url:o.baseUrl,
					data: data,
					type: 'post',
					dataType: 'json',
					success:function(r){
						o.queue--;

						var nNews=$(r.content);

						if(!o.queue){

                            if(data.page){
                                $(o.el).parent().find(o.params.target).append(nNews).fadeIn(300);
                            }else{
                                $(o.el).parent().find(o.params.target).html(nNews).fadeIn(300);
                            }

							$('h1').html(r.meta.h1);

							$('title').text(r.meta.title);
							if(r.meta.metadesc) $('meta[name=description]').attr('content',r.meta.metadesc);
							if(r.meta.metakey) 	$('meta[name=keywords]').attr('content',r.meta.metakey);

                            if(!r.hasNext){
                                o.nextButton.data('disabled', true);
                                o.nextButton.fadeOut();
                            }else{
                                if(o.nextButton.data('disabled')){
                                    o.nextButton.data('disabled', false);
                                    o.nextButton.fadeIn();
                                }

                            }
                            nextButtonOffset = o.nextButton.offset().top;
						}
					}
			})
		}

		if( params=o.parseUrl() ){

			for(var j in params.filters){
				if(o.clearButton.css('display')=='none')
					o.clearButton.show();

				if(params.filters[j] instanceof Array){
					$(o.el).find('[data-switch-tags-type]').val(j).trigger('change');
					$(document).off('click', o.tagsLoseFocus);
					$(o.el).find('.news-inner-tags-container .tags.opened').removeClass('opened')
					params.filters[j].forEach(function(v){
							$(o.el).find('.news-inner-tags-container .tags[data-tags-type='+j+']').find('a[data-id='+v+']').addClass('active');

					})
				}
			}

            if(Object.getOwnPropertyNames(params.filters).length || params.page){
                o.load(params,false);
            }
		}

		o.update = function(page){

			page= page && page>1 ? page : 0;

			var activeTags=o.el.find('a.active[data-id]');
			/*if(activeTags.length<2){

				window.history.pushState(

						{section: activeTags.length ? activeTags.eq(0).data('id') : null, page : page },
						window.title,
						activeTags.length ? activeTags.eq(0).attr('href')+(page==0 ? '' : '?page='+page) : o.baseUrl+(page==0 ? '' : '?&num='+page)
				)
			}
			else{*/
				var tags={};
				var hash=false;

				o.el.find('.news-inner-tags-container .tags').each(function(i,tags){
					tags[$(tags).data('tags-type')]=[];
					if($(tags).find('a.active').length>1) hash=true;
				})

				var url=[];
				activeTags.each(function(i,a){
					var type=$(a).closest('.tags').data('tags-type');
					if(!tags[type])	tags[type]=[];
					tags[type].push($(a).data('id'));
				})

				if(hash){
					for(var i in tags)
						url.push(i+'='+tags[i].join('-'));
				}else{
					activeTags.each(function(i,a){
						url.push($(a).data('url'));
					})
				}



				//console.log(url && clearButton.css('display')=='none', url, !url , clearButton.css('display'), clearButton.css('display')=='none');
				if(url.length && o.clearButton.css('display')=='none')
						o.clearButton.fadeIn(500);
				else{
					if(o.clearButton.css('display')=='block' && !url.length)
						o.clearButton.fadeOut(500);
				}


				window.history.pushState(
						{section: tags,page:page },
						window.title,
							hash ?
							o.baseUrl+'#'+url.join('&')+(page==0 ? '' : '&page='+page)	 :
							o.baseUrl+( url.length ? '/'+url.join('/') : '')+(page==0 ? '' : '/page-'+page)
							//o.baseUrl+'#rubrics='+tags.join('-')+(page==0 ? '' : '&page='+page)
				)
				o.load({filters:tags,page:page})
			//}

		}

	}
})
